module.exports = "https://redage.akamaized.net/src/views/player/documets/images/female.png";